import GroupBadge from "@/components/GroupBadge";

/** Group tag + account name on one line, account number below. */
export default function AccountIdentity({
  group,
  groupColor,
  accountNumber,
  accountName,
  broker,
  showBroker = false,
  large = false,
  bold = false,
  className = "",
}) {
  const weight = bold ? "font-bold" : "";
  return (
    <div className={`min-w-0 ${className}`}>
      <div className="flex items-center gap-2 flex-wrap min-w-0">
        <GroupBadge name={group} color={groupColor} bold={bold} className="shrink-0" />
        <span className={`font-mono-d truncate ${weight} ${large ? "text-base sm:text-lg text-app-text" : "text-[10px] sm:text-xs text-app-text"}`}>
          {accountName || "—"}
        </span>
      </div>
      <div className={`font-mono-d tabular-nums ${weight} ${large ? "text-sm text-app-muted mt-1" : "text-sm mt-0.5 text-app-text"}`}>
        #{accountNumber}
      </div>
      {showBroker && broker && (
        <div className="text-xs text-app-subtle mt-0.5 truncate">{broker}</div>
      )}
    </div>
  );
}
